import { createTRPCReact } from '@trpc/react-query';
import { httpLink } from '@trpc/client';
import type { AppRouter } from 'server/src/trpcServer'; // Import type AppRouter từ server
import { inferRouterInputs, inferRouterOutputs } from "@trpc/server";

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;

export const trpc = createTRPCReact<AppRouter>();

// Tạo client dùng với tRPC Provider
export const trpcClient = trpc.createClient({
  links: [
    httpLink({
      url: "/api/trpc",
      headers: () => {
        const accessToken = new URLSearchParams(window.location.search).get('accessToken');

        return {
          Authorization: `Bearer ${accessToken}`,
        };
      },
    }),
  ],
});
